const getNativeFacebookTokenFromSessionStorage = () => {
  return window.sessionStorage.getItem('native_facebook_token')
}

export default getNativeFacebookTokenFromSessionStorage
